import {
  PurchaseHistory,
  PurchaseHistoryResponse,
  UserInfo,
  UserInfoResponse,
  AccountLimits,
  AccountLimitsResponse,
  AccountCredits,
  AccountCreditsResponse,
} from './types';

export const transformUserInfo = ({
  api_settings,
}: UserInfoResponse): UserInfo => ({
  apiSettings: {
    customLimit: api_settings.custom_limit,
    isTrial: api_settings.is_trial,
    status: api_settings.status,
  },
});

export const transformPurchaseHistory = (
  data: PurchaseHistoryResponse
): PurchaseHistory =>
  data.map(
    ({
      created_at: createdAt,
      product_name: productName,
      amount_cents: amountCents,
      ...item
    }) => ({
      ...item,
      createdAt,
      productName,
      amountCents,
    })
  );

export const transformAccountLimits = (
  response: AccountLimitsResponse
): AccountLimits => ({
  limits: response.limits.map((limit) => ({
    requestType: limit.request_type,
    limit: limit.limit,
    used: limit.used,
  })),
  topUp: {
    total: response.top_up.total,
    used: response.top_up.used,
  },
});

export const transformAccountCredits = ({
  created_at: createdAt,
  payg_credits: paygCredits,
  subscription_credits: subscriptionCredits,
  subscription_credits_total: subscriptionCreditsTotal,
  subscription_period_start: subscriptionPeriodStart,
  ...rest
}: AccountCreditsResponse): AccountCredits => ({
  ...rest,
  createdAt,
  paygCredits,
  subscriptionCredits,
  subscriptionCreditsTotal,
  subscriptionPeriodStart,
});
